var exports = {
  "kL": "xa15a2ab7--98e02f--container",
  "fN": "xa15a2ab7--98e02f--container_no-top-margin",
  "iE": "xa15a2ab7--98e02f--wrapper",
  "$d": "xa15a2ab7--98e02f--collapse-button",
  "wx": "xa15a2ab7--98e02f--header",
};

module.exports = exports;
